export default __webpack_public_path__ + "static/media/project4.de925b62.jpeg";